var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AEE7BE6A-C640-488A-86DB-9895C93ABE83") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.2-Onboarding---Company-Information",
    transform: "translate(-425.000000, -271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(355.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-ui-2",
    transform: "translate(61.000000, 56.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0638298,13.6170213 C18.5624649,13.6170213 18.1560284,14.0234578 18.1560284,14.5248227 L18.1560284,18.1560284 L1.81560284,18.1560284 L1.81560284,14.5248227 C1.81560284,14.0234578 1.4091663,13.6170213 0.907801418,13.6170213 C0.406436539,13.6170213 0,14.0234578 0,14.5248227 L0,19.0638298 C0,19.5651947 0.406436539,19.9716312 0.907801418,19.9716312 L19.0638298,19.9716312 C19.5651947,19.9716312 19.9716312,19.5651947 19.9716312,19.0638298 L19.9716312,14.5248227 C19.9716312,14.0234578 19.5651947,13.6170213 19.0638298,13.6170213 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1808227,6.99642553 L9.07801418,3.09923404 L9.07801418,14.5248227 C9.07801418,15.0261876 9.48445072,15.4326241 9.9858156,15.4326241 C10.4871805,15.4326241 10.893617,15.0261876 10.893617,14.5248227 L10.893617,3.09923404 L14.7908085,6.99642553 C15.1470106,7.34045704 15.7132117,7.33553691 16.0633814,6.98536722 C16.4135511,6.63519753 16.4184712,6.06899644 16.0744397,5.71279433 L10.6276312,0.265985816 C10.2731349,-0.0884034617 9.69849632,-0.0884034617 9.344,0.265985816 L3.89719149,5.71279433 C3.55315998,6.06899644 3.55808011,6.63519753 3.9082498,6.98536722 C4.25841949,7.33553691 4.82462058,7.34045704 5.1808227,6.99642553 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uploadIcon.3600e76f216516d3a519b1b0ad3e8079.svg";